export const getNameInitial = (name: string) => {
  const names = name.split(' ')

  if (names.length === 1) {
    return names[0].charAt(0).toUpperCase()
  }

  if (names.length === 2) {
    return names[0].charAt(0).toUpperCase() + names[1].charAt(0).toUpperCase()
  }

  if (names.length > 2) {
    return names[0].charAt(0).toUpperCase() + names[2].charAt(0).toUpperCase()
  }

  return ''
}
